(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mms-testimonials"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mms-review-carousel')) {
  customElements.define('mms-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.mms-testimonials__cards');
      if (!this.track) return;
      this.cards = Array.from(this.track.querySelectorAll('.mms-testimonials__card'));
      this.controls = this.querySelector('.mms-testimonials__controls');
      this.previous = this.querySelector('[data-direction="previous"]');
      this.next = this.querySelector('[data-direction="next"]');
      this.position = this.querySelector('.mms-testimonials__position');
      this.moreButtons = Array.from(this.querySelectorAll('.mms-testimonials__read-more'));
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true, signal });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * direction);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1);
        }
      }, { signal });
      this.moreButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          button.previousElementSibling.classList.toggle('is-collapsed', expanded);
          button.textContent = expanded ? button.dataset.more : button.dataset.less;
          this.queueUpdate();
        }, { signal });
      });
      this.observer = new ResizeObserver(() => this.refresh());
      this.observer.observe(this.track);
      this.refresh();
      document.fonts.ready.then(() => { if (this.isConnected && this.controller) this.refresh(); });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.controller = null;
      this.frame = null;
    }
    refresh() {
      this.moreButtons.forEach((button) => {
        if (button.getAttribute('aria-expanded') === 'true') return;
        const body = button.previousElementSibling;
        body.classList.add('is-collapsed');
        const overflowing = body.scrollHeight > body.clientHeight + 1;
        button.hidden = !overflowing;
        body.classList.toggle('is-collapsed', overflowing);
      });
      this.update();
    }
    queueUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    }
    update() {
      const track = this.track.getBoundingClientRect();
      if (!track.width || !this.cards.length) return;
      const rects = this.cards.map((card) => card.getBoundingClientRect());
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const overflowing = this.track.scrollWidth > this.track.clientWidth + 2;
      this.controls.hidden = !overflowing;
      this.track.tabIndex = overflowing ? 0 : -1;
      this.previous.disabled = !overflowing || (rtl ? track.right - rects[0].right : rects[0].left - track.left) >= -3;
      this.next.disabled = !overflowing || (rtl ? rects.at(-1).left - track.left : track.right - rects.at(-1).right) >= -3;
      const visible = rects.map((rect, index) => ({ index, width: Math.max(0, Math.min(rect.right, track.right) - Math.max(rect.left, track.left)), fullWidth: rect.width })).filter((card) => card.width >= card.fullWidth / 2);
      if (!visible.length) return;
      const first = visible[0].index + 1;
      const last = visible.at(-1).index + 1;
      const template = first === last ? this.dataset.positionSingle : this.dataset.positionRange;
      const label = template.replace('__FIRST__', String(first)).replace('__LAST__', String(last));
      if (this.position.textContent !== label) this.position.textContent = label;
    }
    move(step) {
      const track = this.track.getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const distances = this.cards.map((card) => {
        const rect = card.getBoundingClientRect();
        return Math.abs(rtl ? rect.right - track.right : rect.left - track.left);
      });
      this.goTo(distances.indexOf(Math.min(...distances)) + step);
    }
    goTo(index) {
      const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!card) return;
      const track = this.track.getBoundingClientRect();
      const rect = card.getBoundingClientRect();
      const style = getComputedStyle(this.track);
      const inset = parseFloat(style.paddingInlineStart) || 0;
      const left = style.direction === 'rtl' ? rect.right - track.right + inset : rect.left - track.left - inset;
      this.track.scrollBy({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
